import i18next from "i18next";

export enum AgentBackUpClient {
    MY_CLIENTS,
    BACKUP_CLIENTS
}

export const AgentBackUpClientLabel = (key: string) => ({ 
    [AgentBackUpClient.MY_CLIENTS]: i18next.t('MY_CLIENTS'),
    [AgentBackUpClient.BACKUP_CLIENTS]: i18next.t('BACKUP_CLIENTS')
})[key];


export enum AgentBackUpLead {
    MY_LEADS,
    BACKUP_LEADS
}

export const AgentBackUpLeadabel = (key: string) => ({ 
    [AgentBackUpLead.MY_LEADS]: i18next.t('MY_LEADS'),
    [AgentBackUpLead.BACKUP_LEADS]: i18next.t('BACKUP_LEADS')
})[key];